import { FC, useCallback } from 'react';

import { x } from '@ui-furniture/style';
import { LineIcon } from '@ui-furniture/ui/line-icon';
import { Popover } from '@ui-furniture/ui/popovers/popover';
import { PopoverMenu } from '@ui-furniture/ui/popovers/popover-menu';

import { ChatState } from '../types/chat-state';

export const ChatMenu: FC<
  Pick<ChatState['internalState'], 'undo' | 'setIsEditing' | 'isEditing'>
> = ({ undo, setIsEditing }) => {
  const toggleEditing = useCallback(() => setIsEditing((is) => !is), []);
  return (
    <x.div position='absolute' bottom='14px' right='14px'>
      <Popover
        position='abovePinnedRight'
        popoverContent={
          <PopoverMenu
            items={[
              {
                id: 'undo',
                label: 'Undo',
                onClick: undo,
              },
              {
                id: 'toggleEditing',
                label: 'Toggle Editing',
                onClick: toggleEditing,
              },
            ]}
          />
        }
        buttonContent={<LineIcon name='infoMenu' size='28px' />}
      />
    </x.div>
  );
};
